import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import './Footer.css';

const Footer = (props) => {

    return(
        <div style={{fontSize: "12px"}}>
            <span className='text-muted font-weight-bold mr-2'>© 2020 - 2026</span>
            &nbsp;
            <span>g2Cloud ERP, S.L.</span>{/* Añadir link a pagina web */}
        </div>

    );
}

export default Footer;